import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import {
  Rss as FeedIcon,
} from 'react-feather';


const Capability = () => (
  <>
    <Helmet>
      <title>Capability</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <FeedIcon />
        <Box sx={{ pt: 3 }}>

          <Typography paragraph>This is Capability. Coming Soon</Typography>
        </Box>
      </Container>
    </Box>
  </>
);

export default Capability;
